import { render, staticRenderFns } from "./SingleLayout.vue?vue&type=template&id=e6233b0c&scoped=true"
import script from "./SingleLayout.vue?vue&type=script&lang=js"
export * from "./SingleLayout.vue?vue&type=script&lang=js"
import style0 from "./SingleLayout.vue?vue&type=style&index=0&id=e6233b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6233b0c",
  null
  
)

export default component.exports